/**
 * Copyright 2022 (C) Blink - All Rights Reserved
 *
 * This source code is protected under international copyright law.  All rights
 * reserved and protected by the copyright holders.
 * All files are confidential and only available to authorized individuals with the
 * permission of the copyright holders. If you encounter any file and do not have
 * permission, please get in touch with the copyright holders and delete this file.
 */
import cn from "classnames";
import { lazy } from "react";

import { useEnvs } from "state/EnvironmentsContext/EnvContext";

const LottiefilePlayer = lazy(
  () => import("./../../common/Icon/LottiefilePlayer"),
);

interface ILoading {
  bgColor?: string;
  className?: string;
  loaderSrc?: string;
}

const Loading = ({ bgColor = "#1a1a1a", className }: ILoading) => {
  const loadingScreen = useEnvs((state) => state.loading) || "";
  return (
    <div className={cn(className)} test-id="kzcK7Jrv">
      <LottiefilePlayer
        src={loadingScreen}
        background={bgColor}
        className={className}
        loop
        autoplay
        test-id="AE6aQWYV"
      />
    </div>
  );
};

export default Loading;
